/**
 * List Schema of MascaraTransportadorSacPublico
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {MascaraTransportadorSacPublico} from '@/model/resource/MascaraTransportadorSacPublico'

/* TODO: review generated schema */
export class ListMascaraTransportadorSacPublicoSchema extends Schema {
  readonly name = 'ListMascaraTransportadorSacPublico'

  readonly fieldSet: FieldSet<MascaraTransportadorSacPublico> = {
    idMascaraTransportadorSacPublicoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
